import { render, staticRenderFns } from "./ArchivedAssetReport.vue?vue&type=template&id=6380801b&scoped=true"
import script from "./ArchivedAssetReport.vue?vue&type=script&lang=js"
export * from "./ArchivedAssetReport.vue?vue&type=script&lang=js"
import style0 from "./ArchivedAssetReport.vue?vue&type=style&index=0&id=6380801b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380801b",
  null
  
)

export default component.exports